export const siteConfig = {
  companyName: "M B Exim",
  tagline: "India's Prominent Honey Exporter",
  logo: "https://mbexim.org/img/mb-logo-white.png",
  heroSubtext: "Premium bulk honey exporter with nearly three decades of industry experience",
};

export const navigation = [
  {
    label: "Products",
    hasDropdown: true,
    items: [
      { label: "Private Label", href: "#services" },
      { label: "Bulk & Institutional", href: "#services" },
    ],
  },
  { label: "Varieties", href: "#varieties" },
  { label: "About", href: "#about" },
  { label: "Quality", href: "#quality" },
];

export const heroSlides = [
  {
    heading: "India's Prominent Honey Exporter",
    subheading: "Bulk & Customer Packs",
    cta: "Make An Enquiry",
    image: "https://images.unsplash.com/photo-1623018697148-8350cf18e64e",
  },
  {
    heading: "Three Decades of Trust",
    subheading: "Premium Quality Since 1995",
    cta: "Explore Products",
    image: "https://images.unsplash.com/photo-1718146921295-700b969e7c78",
  },
];

export const tagline = {
  line1: "Relentless Quality.",
  line2: "25+ Years of Trust.",
  line3: "India's Trusted Honey Supplier.",
};

export const honeyVarieties = [
  {
    name: "Mustard Honey",
    image: "https://customer-assets.emergentagent.com/job_mbexim-studio/artifacts/zqngo385_mustard.png",
    description: "Rich golden honey from vibrant mustard fields.",
  },
  {
    name: "Eucalyptus Honey",
    image: "https://customer-assets.emergentagent.com/job_mbexim-studio/artifacts/0sw60p0p_Eucalyptus.png",
    description: "Light amber with soothing herbal notes.",
  },
  {
    name: "Litchi Honey",
    image: "https://customer-assets.emergentagent.com/job_mbexim-studio/artifacts/zhckfltc_litchi.png",
    description: "Delicate sweetness from fragrant litchi orchards.",
  },
  {
    name: "Acacia Honey",
    image: "https://customer-assets.emergentagent.com/job_mbexim-studio/artifacts/qffjkozh_acacia.png",
    description: "Mild and delicate with a clear golden hue.",
  },
  {
    name: "Wild Honey",
    image: "https://customer-assets.emergentagent.com/job_mbexim-studio/artifacts/tcq2s5cq_Wild.png",
    description: "Bold and untamed from pristine forest regions.",
  },
  {
    name: "Sidr Honey",
    image: "https://customer-assets.emergentagent.com/job_mbexim-studio/artifacts/edtay1f0_Sidr%20Background%20Removed.png",
    description: "Rare and prized honey from the Sidr tree.",
  },
];

export const moreVarieties = [
  { name: "Sunflower", icon: "sun" },
  { name: "Mustard", icon: "flower" },
  { name: "Berry", icon: "cherry" },
  { name: "Tulsi", icon: "leaf" },
  { name: "Wild", icon: "trees" },
];

export const qualitySection = {
  title: "Quality Assurance",
  description: "Through comprehensive internal and third-party testing, we ensure only the best honey reaches our customers. Our state-of-the-art lab facilities and rigorous protocols guarantee 100% pure, unadulterated honey.",
  cta: "Learn More",
  image: "https://images.unsplash.com/photo-1758522965167-42e34a12bf13",
  stats: [
    { value: "100%", label: "Pure Honey" },
    { value: "30+", label: "Years Experience" },
    { value: "50+", label: "Countries Served" },
  ],
};

export const expertiseSection = {
  title: "Three Decades of Excellence",
  description: "M B Exim has a history of being recognized as a trusted honey exporter. Our commitment to quality and consistency has earned us partnerships with leading brands worldwide.",
  subtext: "We put care into sourcing and processing honey with unmatched quality standards.",
  cta: "Our Story",
  image: "https://images.unsplash.com/photo-1642067958024-1a2d9f836920",
};

export const pureSection = {
  title: "Ingredient: Pure Honey",
  lines: [
    "100% natural honey sourced directly from beekeepers.",
    "No shortcuts. No additives. No artificial ingredients.",
    "Just the highest-quality, best-tasting honey for the world.",
  ],
};

export const productTypes = [
  {
    title: "Private Label",
    subtitle: "Custom Packaging Solutions",
    description: "We offer comprehensive private label solutions — from custom branding and packaging design to flexible order quantities. Your brand, our premium honey.",
    cta: "Explore Private Label",
    image: "https://images.pexels.com/photos/14168472/pexels-photo-14168472.jpeg",
  },
  {
    title: "Bulk & Institutional",
    subtitle: "Large Scale Supply",
    description: "Serving food manufacturers, pharmaceutical companies, and institutional buyers with consistent, high-volume honey supply in drums, barrels, and tankers.",
    cta: "Explore Bulk Options",
    image: "https://images.unsplash.com/photo-1761416351532-ede97c29fab8",
  },
];

export const businessSegments = [
  { title: "Food & Beverages", icon: "utensils" },
  { title: "Pharmaceuticals", icon: "pill" },
  { title: "Cosmetics", icon: "sparkles" },
  { title: "Retail & E-commerce", icon: "store" },
  { title: "Hospitality", icon: "hotel" },
];

export const clients = [
  { name: "Prakriti Organics", logo: "https://mbexim.org/img/Prakriti-Organics-logo.png" },
  { name: "Shreejee Honey", logo: "https://mbexim.org/img/shreejee-honey-logo.png" },
  { name: "Dabur", logo: "https://mbexim.org/img/Dabur_logo.png" },
  { name: "Mehta Group", logo: "https://mbexim.org/img/Mehta-group%20companies-logo.png" },
  { name: "Patanjali", logo: "https://mbexim.org/img/patanjali-logo-2.png" },
];

export const storySection = {
  title: "From Beekeepers to Your Doorstep",
  subtitle: "Nearly Three Decades of Honey Expertise",
  description: "M B Exim's journey began with a passion for honey and a belief in the value of supporting small businesses. Now we are entrusted with sourcing from thousands of beekeepers across India, bringing 100% pure honey to your table directly from the source.",
  cta: "Our Story",
  image: "https://images.unsplash.com/photo-1758522965231-4d7dde21ae7b",
};

export const aboutSection = {
  title: "About M B Exim",
  description: "M B Exim Pvt. Ltd. is a premium exporter of bulk honey with industry experience spanning nearly three decades. Our journey began with a passion for honey and a belief in the value of supporting small businesses. We take pride in our product and are committed to providing exceptional quality honey to our customers.",
  image: "https://images.unsplash.com/photo-1758522965366-a6ab0e8f2e63",
};

export const contactInfo = {
  heading: "Get in Touch",
  subheading: "Stay updated and help us make a positive impact on the honey industry worldwide.",
  email: "info@mbexim.org",
  social: [
    { platform: "facebook", url: "#" },
    { platform: "twitter", url: "#" },
    { platform: "linkedin", url: "#" },
    { platform: "instagram", url: "#" },
  ],
};

export const footerLinks = [
  {
    title: "Products",
    links: [
      { label: "Our Services", href: "#services" },
      { label: "Bulk & Institutional", href: "#services" },
      { label: "Honey Varieties", href: "#varieties" },
    ],
  },
  {
    title: "Company",
    links: [
      { label: "About Us", href: "#about" },
      { label: "Quality Assurance", href: "#quality" },
      { label: "Packaging", href: "#services" },
    ],
  },
  {
    title: "Contact",
    links: [
      { label: "Get In Touch", href: "#contact" },
      { label: "info@mbexim.org", href: "mailto:info@mbexim.org" },
    ],
    address: "231/3, Village Kumar Hera, Dehradun Road, Saharanpur, India",
  },
];
